"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _components = require("../../../components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _core = require("@material-ui/core");

var _dateFns = require("date-fns");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    unread: {
      fontWeight: 'bold'
    }
  };
});

var NotificationCard = function NotificationCard(_ref) {
  var _ref$notifications = _ref.notifications,
      notifications = _ref$notifications === void 0 ? [] : _ref$notifications,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["notifications", "className"]);

  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_components.StandardDisplayCard, {
    className: (0, _clsx.default)(classes.root, className),
    title: t('dashboard.notificationsTitle')
  }, (notifications === null || notifications === void 0 ? void 0 : notifications.length) < 1 && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, t('dashboard.noNotificationsMessage')), /*#__PURE__*/_react.default.createElement(_core.List, null, notifications && notifications.map(function (notification, i) {
    var title = notification.title,
        message = notification.message,
        timestamp = notification.timestamp,
        unread = notification.unread;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      button: true
    }, /*#__PURE__*/_react.default.createElement(_components.Flex, {
      dir: "ttb"
    }, timestamp && timestamp.toDate && /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "caption"
    }, (0, _dateFns.formatDistance)(timestamp.toDate(), new Date(), {
      addSuffix: true
    })), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      classes: {
        primary: unread ? classes.unread : '',
        secondary: unread ? classes.unread : ''
      },
      primary: title,
      secondary: message || null
    }))), i < notifications.length - 1 && /*#__PURE__*/_react.default.createElement(_core.Divider, null));
  })));
};

exports.NotificationCard = NotificationCard;
NotificationCard.propTypes = {
  notifications: _propTypes.default.arrayOf({
    title: _propTypes.default.string.isRequired,
    message: _propTypes.default.string,
    timestamp: _propTypes.default.object.isRequired,
    unread: _propTypes.default.bool.isRequired
  })
};
var _default = NotificationCard;
exports.default = _default;